import { render, staticRenderFns } from "./AttachmentsSectionSearch.vue?vue&type=template&id=27ce04d7&scoped=true&"
import script from "./AttachmentsSectionSearch.vue?vue&type=script&lang=js&"
export * from "./AttachmentsSectionSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ce04d7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
